export const createPaginationSelector = tableId => state => {
  let tableState = state.table[tableId];
  if (tableState) return tableState;
};